import { createContext, useState, useContext } from 'react';

const LoadedContext = createContext();

export function useLoaded() {
  return useContext(LoadedContext);
}

export function LoadedProvider({ children }) {
  const [loaded, setLoaded] = useState(false);

  return <LoadedContext.Provider value={{ loaded, setLoaded }}>{children}</LoadedContext.Provider>;
}
